export function moveCursorToEnd(id: string) {
    var el = document.getElementById(id)!;
    el.focus();
    // select all the content in the element
    document.execCommand("selectAll", false);
    // collapse selection to the end
    document.getSelection()!.collapseToEnd();
}